var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-list"}},[_c('div',{staticClass:"product-list"},[_c('ul',{staticClass:"products"},_vm._l((_vm.products),function(product,product_index){return _c('li',{key:product_index,class:{ 'matched': true,
                          'bike' : true,
                          'kind-f': product.gender == 'F',
                          'kind-m': product.gender == 'M',
                          'kind-k': product.gender == 'K'}},[_c('item',{attrs:{"product":product}})],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b5cab18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/SeriesBikesList.vue
// module id = null
// module chunks = 